import FetchFactory, {
	DeleteRequest,
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import { StatusType, Update } from "document/StatusTypes";
import { TrajectoryInfo } from "./TrajectoryService";

const ENDPOINT = "/api/v2/trajectories";

export default class TrajectoryClient {
	public static getAllWithStatus(
		status: StatusType
	): GetRequest<Array<TrajectoryInfo>> {
		return FetchFactory.get(`${ENDPOINT}?status=${status}`);
	}

	public static updateStatus(
		id: number,
		data: Update
	): ModifyRequest<Update, void> {
		return {
			operation: "PUT",
			url: `${ENDPOINT}/${id}/status`,
			body: data,
			statusCode: 200,
			callback: () => Promise.resolve()
		};
	}

	public static delete(id: number): DeleteRequest<void> {
		return FetchFactory.del(`${ENDPOINT}/${id}`);
	}
}
